export const contest = {
    qjy: '거래',
    grbm: '개인 등록',
    qdl: '로그인하러 가기',
    bsyjs: '대회가 이미 종료되었습니다',
    bsjs: '대회 종료됨',
    djs: '모의 거래 대회까지 {v1} 남음 (카운트다운)',
    days: '일',
    hours: '시간',
    minutes: '분',
    seconds: '초',
    ljyq: '즉시 초대',
    tdbm: '팀 등록',
    qzc: '회원가입하러 가기',
    qrsfgrbm: '개인 등록에 참가하시겠습니까?',
    qxbm: '등록 취소',
    qrbm: '등록 확인',
    gxnbmcg: '등록이 성공적으로 완료되었습니다. 10만 USDT 모의 자금을 받게 됩니다.',
    xzjs: '원하는 역할을 선택하세요',
    cwty: '팀원이 되기',
    cwtz: '팀장이 되기',
    cjtd: '팀 생성',
    jtgz: '팀 생성 규칙:',
    jtgz1: '1. 팀 생성 후 24시간 동안 5명 미만일 경우 자동 해체되며 자동으로 모의 개인 경기에 등록됩니다.',
    jtgz2: '2. 팀이 생성될 때까지 모의 개인 경기에 등록할 수 없습니다.',
    jtgz3: '3. 팀이 생성된 후 다른 팀 및 모의 개인 경기에 참여할 수 없습니다.',
    tdmc: '팀 이름:',
    tdjj: '팀 소개:',
    ljjt: '즉시 팀 생성',
    tdmcbt: '팀 이름을 입력하세요',
    tdjzbt: '팀 소개를 입력하세요',
    cjzdcg: '팀 생성이 성공적으로 완료되었습니다!',
    xzjrtd: '가입하고 싶은 팀을 선택하세요',
    sstdmc: '팀 이름 검색',
    dqzdsl: '현재 팀 수: {v1}, 가입하고 싶은 팀을 선택하세요',
    ddtdrs: '현재 팀 인원: {v1}명',
    tdrs: '팀 인원:',
    tzmc: '팀장 이름:',
    jrtd: '팀 가입',
    jrzdcg: '팀 가입이 성공적으로 완료되었습니다!',
    grfxlj: '개인 공유 링크:',
    grtjm: '개인 추천 코드:',
    tdfxlj: '팀 공유 링크:',
    tdtjm: '팀 추천 코드:',
    tdtzm: '팀장 이름:',
    bctp: '이미지 저장',
    total: '총 {v1} 개',
    dd: '페이지로 이동',
    qd: '확인',
    cyyj: '참여하면 상금이 주어집니다',
    jcdnn: 'USDT 상금 풀에서 기다립니다!',
    jzcj: '수익 기부, 추첨에 참여하세요',
    dqjc: '현재 상금 풀:',
    qjz: '기부하러 가기',
    jzsm: '기부 설명',
    kjz: '현재 {v1} USDT를 기부할 수 있습니다. 기부하시겠습니까?',
    qxjz: '기부 취소',
    qrjz: '기부 확인',
    jzcg: '기부가 성공적으로 완료되었습니다!',
    mnpjyds: '모의 거래 대회',
    bm: '등록:',
    bs: '대회:',
    hyspjyds: '합의 거래 경기',
    xhspjyds: '현물 거래 경기',
    bmz: '등록 중',
    jqqd: '기다려 주세요',
    bsz: '대회 중',
    yjs: '종료됨',
    myptts: '모의 팀 경기',
    mypzmxs: '주간 스타 경기',
    mypgrs: '모의 개인 경기',
    hyjyds: '합의 거래 경기',
    xhjyds: '현물 거래 경기',
    my: '나의',
    pm: '순위',
    dync: '팀원 닉네임',
    dm: '팀명',
    zdrs: '팀 인원',
    nc: '닉네임',
    ljzjy: '누적 총 거래',
    ljzjye: '누적 거래액',
    ljzyll: '누적 총 수익률',
    zyll: '총 수익률',
    zdjl: '팀 보상',
    mypbsjl: '참가 상금',
    myphycs: '모의 합의 거래에 참여하기',
    myhyj: '등록 성공 시 10만 U 모의 합의 자금을 획득합니다',
    ljbm: '즉시 등록',
    tzjl: '팀 생성 상금',
    ztcg: '5명이 팀을 만들면 200명으로 제한됩니다',
    bwzbhl: '팀장이 팀을 성공적으로 만들면 10만 U+를 받습니다',
    yqjl: '초대 상금',
    yqhycybs: '팀장 초대 시 최대 10만 U를 받을 수 있습니다',
    hzhyj: '팀원 초대 시 최대 5만 U를 받을 수 있습니다',
    mnttbssm: '모의 대회 팀 경기 경기 규칙 설명',
    // 团队赛规则
    csxq: '참가 세부 정보:',
    csxq1: '1. 활동 등록 시작일 - 대회 종료일 사이에 사용자(본인인증 필요)는 자유롭게 팀을 개설할 수 있습니다. 합의 팀 경기는 팀 인원 ≥ 5명이고 ≤ 200명이어야 하며, 팀이 생성된 후 24시간 이내에 5명 미만으로 채워지면 팀이 자동 해산되며 팀원은 자동으로 개인 경기 지역으로 이동합니다.',
    csxq2: '2. 사용자는 한 번의 팀 선택과 가입만 가능하며, 중복 참가나 팀 경기 및 개인 경기 동시 참여가 불가능하며, 사용자는 팀 가입 후 자발적으로 팀을 탈퇴할 수 없습니다.',
    ssgz: '대회 규칙:',
    ssgz1: '1. 팀장 혜택: 1) 팀장은 한 명의 팀원을 초대할 때마다 1000USDT 모의 자금을 받을 수 있으며, 초대 보상은 100000USDT로 한정됩니다.',
    ssgz1_2: '2) 팀장이 20명 이상의 친구를 성공적으로 초대하고 거래하면 코인왕의 멋진 주변 장비를 받을 수 있습니다.',
    ssgz2: '2. 팀원 혜택: 팀원이 한 명의 친구를 초대할 때마다 500USDT 모의 합의 자금을 받을 수 있으며, 초대 보상은 50000USDT로 한정됩니다.',
    ssgz3: '3. 팀 경기가 종료된 후 플랫폼은 팀의 실제 총 거래액을 기준으로 최종 총 순위를 결정합니다.',
    ssgz4: '4. 모의 대회 팀 경기 지역의 총 거래액은 매일 0시에 업데이트됩니다.',
    ssgz5: '5. 대회 결과의 공정성을 보장하기 위해 악의적인 거래를 금지합니다. 악의적인 거래 및 거래 데이터 조작이 발견되면 biking 고객 서비스 팀이 개입할 것입니다. 모의 대회 팀 경기 지역의 총 거래액은 매일 0시에 업데이트됩니다.',
    ssgz6: '6. 자세한 활동 규칙은 biking 고객 서비스 팀에 문의하십시오.',
    jlfp: '보상 분배:',
    jlfp1: '1. USDT 상금 분배: (상금 배분 시, 모의 합의 특별 자금과 현금은 항상 9:1 비율로 분배됩니다)',
    jlfp1_1: '1) 팀 내부 분배 비율:',
    jlfp1_2: '팀장은 상금을 받을 수 있습니다. = 팀장 개인 누적 합의 거래액 / Biking 모의 대회 팀 경기 총 거래액 * 5000000USDT',
    jlfp1_3: '+ 팀 내 다른 팀원의 업적 총합 / Biking 모의 대회 팀 경기 총 거래액 * 20% * 5000000USDT.',
    jlfp1_4: '팀원은 상금을 받을 수 있습니다. = 해당 사용자의 현재 누적 합의 거래액 / Biking 모의 대회 팀 경기 총 거래액 * 80% * 5000000USDT.',
    jlfp1_5: '2) 대회 기간 동안 우수한 성적을 거둔 팀은 집단 수익 추가 혜택을 누릴 수 있습니다! 수익 추가 비율은 팀 인원 및 팀 총 거래액을 기준으로 하며, 팀 인원 / 총 거래액이 2배씩 증가할 때마다 50%의 계산 능력이 추가됩니다.',
    myptdjyze: '모의 대회 팀 경기 총 거래액',
    myptdphb: '모의 대회 팀 순위표',
    tdsl: '현재 팀 수: {v1}, 가입하고 싶은 팀을 선택하세요',
    tznc: '팀장 닉네임:',
    tdjs: '팀 소개:',
    // 周明星规则
    mypzmxgzsm: '모의 대회 주간 스타 경기 경기 규칙 설명',
    zmxphb: '주간 스타 팀 순위표 (상위 3위만 표시)',
    zmxtdphb: '주간 스타 팀 순위표',
    bdxq: '랭킹 세부 정보:',
    bdxq1: '1. 전투 팀을 성공적으로 구성하고 거래를 시작하면 자동으로 주간 스타 팀 순위에 참여합니다.',
    zmxgz: '1. 시스템은 매 주를 한 주기로 하여 현재 참가 팀을 총 거래액에 따라 순위를 매기고 "주간 스타 팀 순위"를 공개합니다. 순위표 상위 3위 팀은 2000000USDT 모의 합의 자금 상금을 나누게 됩니다.',
    zmxgz1: '2. 주간 스타 팀 순위는 매주 수요일 오후 2시에 업데이트됩니다.',
    bddym: '1위 팀은 1000000USDT 모의 합의 자금을 받습니다.',
    dbdem: '2위 팀은 600000USDT 모의 합의 자금을 받습니다.',
    bddsm: '3위 팀은 400000USDT 모의 합의 자금을 받습니다.',
    tdnbfpgz: '팀 내부 분배 규칙:',
    tzx: '팀장은 20%를 즐깁니다.',
    nbyjpm: '팀 내부에서 10위권에 드는 팀원(팀장 제외)은 40%를 분배합니다.',
    syty: '나머지 팀원은 40%를 분배합니다.',
    // 个人赛规则
    mypgrsgzsm: '모의 개인 경기 경기 규칙 설명',
    mypgrphb: '모의 대회 개인 순위표',
    bsxz: '대회 주의사항:',
    bsxz1: '1. 각 새로운 사용자가 대회에 등록하면 100000USDT 모의 합의 자금을 받습니다.',
    bsxz2: '2. 기존 사용자가 대회에 등록하면 50000USDT 모의 합의 자금을 받습니다.',
    bsxz3: '3. 대회 기간 동안 사용자는 친구를 초대하여 체험 자금을 계속 받을 수 있습니다:',
    bsxz4: '1) 사용자가 친구를 한 명 초대하면 2000USDT 모의 체험 자금을 받습니다.',
    // bsxz5: '2) Invite an old user to participate in the competition and get 2000 USDT experience money:',
    bsxz6: '2) 최대 누적 50000USDT 모의 합의 자금을 받을 수 있는 최대 상한선을 설정합니다.',
    bsxz7: '3. 이 대회 영역은 코인왕 거래소의 실명 인증 사용자에게만 공개됩니다.',
    bsxz8: '4. 대회 종료 후 참가자의 최종 총 거래액을 기준으로 개인 경기 영역 순위가 결정됩니다.',
    grgzsm1: '1. 총 상금 풀: 2000000USDT + 30개의 고급 주변 제품',
    grgzsm2: '2. 상금 배분 세부 정보:',
    grgzsm3: '1등: 800000USDT + 5개의 고급 주변 제품',
    grgzsm4: '2등: 500000USDT + 5개의 고급 주변 제품',
    grgzsm5: '3등: 200000USDT + 3개의 고급 주변 제품',
    grgzsm6: '4-20등: 500000USDT의 일부 + 17개의 고급 주변 제품',
    hyjybs: '합의 거래 대회',
    hyjybsgzsm: '합의 거래 대회 규칙 설명',
    hyspgrphb: '합의 대회 개인 순위표',
    // 合约大赛规则
    csxz: '대회 주의사항:',
    hybsgz1: '1. 합의 거래 대회에 등록하면 100USDT의 합의 전용 자금을 받습니다(전용 자금 사용 규정은 플랫폼과 관련 규정을 참조하십시오). 이 전용 자금 거래 수익은 대회 참가 기간의 총 수익률에 포함되지 않습니다.',
    hybsgz2: '2. 사용자는 친구를 합의 거래 대회에 초대하여 성공적으로 초대할 경우 20USDT 합의 전용 자금 보너스를 받습니다. 초대 보너스 상한은 100USDT입니다.',
    hybsgz3: '3. 이 대회 영역은 코인왕 거래소의 실명 인증 사용자에게만 공개됩니다.',
    hybsgz4: '4. 대회 종료 후 시스템은 대회 기간 동안 사용자의 총 수익률을 기준으로 대회 순위를 결정합니다.',
    jcfp: '상금 분배:',
    jcfp1: '총 상금 풀: 2000000USDT + 30개의 고급 주변 제품',
    fpgz: '배분 규칙:',
    fpgzs: '(상금 지급 시, 합의 전용 자금과 현금은 항상 9:1 비율로 분배됩니다)',
    fpgz1: '1등: 800000USDT + 5개의 고급 주변 제품',
    fpgz2: '2등: 500000USDT + 5개의 고급 주변 제품',
    fpgz3: '3등: 200000USD+3개의 고급 주변 제품',
    fpgz4: '4-20등: 500000USDT 일부 + 17개의 고급 주변 제품',
    hjyq: '수상 조건',
    hjyq1: '1. 합의 대회 수익 = 계정 최종 순 자산 (미실현 손익 포함) - 계정 초기 순 자산 (미실현 손익 포함) - 참가 합의 자금.',
    hjyq2: '2. 수익이 동일한 참가자가있는 경우 거래 금액이 더 높은 쪽이 승리합니다.',
    hjyq3: '3. 수상한 사용자는 계정 수익이 0보다 큰지 확인해야 합니다.',
    // 捐赠
    gyc1: '이 상금 풀은 합의 거래 대회 영역 및 현물 거래 대회 영역의 사용자에게만 개방되며, 사용자는 대회를 조기에 종료하고 현재 거래액/수익률을 기부로 지정할 수 있습니다.',
    gyc2: '시스템은 각 수익 포인트당 0.5USDT의 비율로 기부 상금을 공익 풀에 지급하며, 상금 잔액은 대회 페이지에서 공개됩니다.',
    gyc3: '예를 들어 사용자 A의 실제 수익률이 38%이면 이 사용자가 기부할 때 시스템은 38 * 0.5 = 19USDT를 공익 풀에 입금합니다(공익 상금은 합의 전용 자금입니다).',
    gyc4: '공익 풀 누적 금액 상한: 50000USDT 합의 전용 자금',
    gyc5: '사용자가 거래액을 기부할 때, 시스템은 각각 100USDT 거래액당 0.5USDT의 공익 자금을 공익 풀에 기부합니다. 예를 들어 B 사용자의 총 거래액이 1000USDT이면, 공익 풀에 기부되는 금액은 0.5USDT * 10 = 5USDT입니다(공익 상금은 합의 전용 자금입니다).',
    gyc7: '기부 주의사항: 각 사용자는 한 번의 공익 기부만 참여할 수 있으며, 기부가 성공하면 사용자는 biking 거래 대회의 순위 자격, 수상 자격 및 참가 자격을 포기한 것으로 간주됩니다(합의 거래 대회 영역 사용자는 공익 기부 후 후속 현물 거래 대회에 참여할 수 없습니다).',
    gyc8: '대회 종료 후, 공익 상금 풀은 3회의 추첨을 진행하며, 각 회마다 10명의 당첨자에게 상금을 분배합니다. 세 번의 추첨의 상금 분배 비율은 각각 40%, 30%, 30%입니다.',
    gyc9: '추첨 일정: 거래 대회 종료 후 7개 근무일 이내에 무작위로 추첨됩니다. 자세한 내용은 공식 직원에게 문의하십시오.',
    xhjybs: '현물 거래 대회',
    xhjybsgzsm: '현물 거래 대회 규칙 설명',
    xhjydsphb: '현물 거래 대회 순위표',
    grbmcg: '개인 등록 성공!',
    // 现货实大赛规则
    xhgz1: '1. 현물 거래 대회는 플랫폼의 모든 현물 거래 쌍을 포함합니다.',
    xhgz2: '2. 참가자는 플랫폼의 현물 계정 잔액이 50USDT 이상이어야 합니다.',
    xhgz3: '3. 대회 종료 후, 플랫폼은 사용자의 총 현물 거래액을 기준으로 대회 영역의 총 순위를 결정합니다.',
    jjfp: '상금 분배',
    zjc: '총 상금 풀: 1000000USDT + 20개의 고급 주변 제품',
    xhdym: '1등: 400000USDT + 10개의 주변 제품',
    xhdem: '2등: 200000USDT + 5개의 주변 제품',
    xhdsm: '3등: 100000USDT + 5개의 주변 제품',
    xhdsm1: '4-20등: 300000USDT 분배',
    mypdnpm: '모의 대회 내부 순위표',
    yqjl1: '초대 보너스',
    wdjye: '내 거래액:',
    wdzsyl: '내 총 수익률:',
    grzjyl: '모의 대회 개인 총 거래액:',
    grzsyl: '모의 대회 개인 총 수익률:',
    sqzjye: '모의 대회 영역 총 거래액:',
    zjye: '영역 총 거래액:',
    bsyqrs: '대회 초대 인원 수:',
    ren: '명',
    hdmnj: '받은 모의 자금:',
    hdzj: '받은 선물 자금:',
    hyjyxq: '합의 거래 대회 상세 정보',
    xhjyxq: '현물 거래 대회 상세 정보',
    hy: '합의',
    xh: '현물',
    jlsm: '상금 설명',
    jlsm1: '1. 대회 기간 동안 사용자(실명 인증 필요)는 자유롭게 팀을 생성할 수 있으며, 합의 팀 경기는 팀원 수 ≥ 5명, ≤ 200명이어야 합니다. 24시간 이내에 5명이 모이지 않으면 팀이 자동 해체됩니다.',
    jlsm2: '2. 각 사용자는 한 번만 팀에 가입할 수 있으며 중복으로 가입할 수 없으며, 팀에서 자유롭게 탈퇴할 수 없습니다.',
    tdjye: '팀 거래액:',
    wdjs: '내 역할:',
    dz: '팀장',
    dy: '팀원',
    tdzyll: '팀 총 수익률:',
    wdzyll: '내 총 수익률:',
    tdyjhdjl: '팀 예상 보상:',
    tdjs1: '팀 소개',
    grxq: '개인 세부 정보',
    tdxq: '팀 세부 정보',
    tdjylpm: '팀 거래량 순위:',
    tdzsyl: '팀 총 수익률',
    tdnphb: '팀 내부 순위표',
    tcsybs: '팁: 기부를 완료하면 모든 대회에서 탈퇴됩니다.',
    zwcjhybs: '합의 거래 대회에 아직 참여하지 않았습니다.',
    zwsj: '데이터 없음',
    tdmcbzq: '팀 이름 형식이 잘못되었습니다.',
    tdjjbzq: '팀 소개 형식이 잘못되었습니다.',
    hdjxz_contract: '영구 합의 계약 거래 대회가 치열하게 진행되며, 대회에 참가하여 2000000U 상금을 나누고 풍부한 코인 왕 제품을 얻으세요.',
    hdjxz_spot: '현물 거래 대회가 치열하게 진행되고 있으며, 대회에 참가하여 1000000U 상금을 나누고 풍부한 코인 왕 제품을 얻으세요.',
    hdjs: '다음 라운드 대회 시작을 기대해주세요.',
  }


// WEBPACK FOOTER //
// ./src/i18n/lang/contest/kr.js